import { Fragment, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { formatDateToKoreanWithWeekday } from 'shared/lib';
import { useGetJsonParams } from 'shared/lib/useGetJsonParams';
import { Tabs } from 'shared/ui';
import arrow from 'styles/images/arrow-icon-24.png';
import cautionIcon from 'styles/images/caition-icon.svg';
import inspectEmptyIcon from 'styles/images/empty-icon.png';

import { useGetPactTest } from '../api';
import { labelClass, pactTypeTitle, testType } from '../const';

import './kareNote.css';

//  페이지전환 탭
const DETAIL_TABS = [
  { key: 'medical', label: '진료 내역' },
  { key: 'test', label: '검사 내역' },
];

export const Pact = () => {
  const navigate = useNavigate();
  const { pactType, departmentName, pactStartDate, pactEndDate, doctorName, pactTab } = useGetJsonParams();

  // const data = useGetDiagnoses({
  //   hspId,
  //   pactId,
  //   enabled: pactType === 'I' || pactType === 'O',
  // });

  const [activeTab, setActiveTab] = useState(pactTab || 'medical');

  useEffect(() => {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    params.pactTab = activeTab;
    navigate(`?${new URLSearchParams(params).toString()}`, {
      replace: true,
    });
  }, [activeTab]);
  return (
    <div className='medical-page'>
      <div className='medical-page-wrap'>
        <div className='wrapper'>
          {/* 페이지 전환 탭 */}
          <div className='page-tabs'>
            <Tabs tabs={DETAIL_TABS} activeTab={activeTab} onChange={setActiveTab} variant='page' />
          </div>

          {/* 진료 내역 */}
          {activeTab === 'medical' && (
            <div className='medical-history'>
              <div className='medical-history__list'>
                <div className='medical-history__item'>
                  <div className='medical-history__header'>
                    <div className='medical-history__tags'>
                      <div className={`medical-history__tag-label`}>
                        <span className={`medical-history__tag ${labelClass[pactType]}`}>
                          {pactTypeTitle[pactType]}
                        </span>
                      </div>
                      <span className='medical-history__department'>{departmentName}</span>
                    </div>

                    {/* <h1 className='medical-history__title'>{diagnosisName}</h1> */}
                  </div>

                  <div className='medical-history__cards'>
                    <div className='medical-history__card'>
                      <div className='medical-history__row'>
                        <span className='medical-history__label'>진료 구분</span>
                        <span className='medical-history__value'>{pactTypeTitle[pactType]}</span>
                      </div>

                      <div className='medical-history__divider ' />

                      <div className='medical-history__row'>
                        <span className='medical-history__label'>진료일</span>
                        <span className='medical-history__value'>
                          {formatDateToKoreanWithWeekday(pactStartDate.replace(/-/g, ''))}
                          {pactEndDate && ` ~ ${formatDateToKoreanWithWeekday(pactEndDate.replace(/-/g, ''))}`}
                        </span>
                      </div>

                      <div className='medical-history__divider ' />

                      <div className='medical-history__row'>
                        <span className='medical-history__label'>의료진</span>
                        <span className='medical-history__value'>{doctorName}</span>
                      </div>
                    </div>
                    {/* 
                    {data && (
                      <div className='medical-history__card'>
                        <div className='medical-history__row'>
                          <span className='medical-history__label'>진단 코드</span>
                          <span className='medical-history__value'>{data.data.diagnosisCode}</span>
                        </div>

                        <div className='medical-history__divider ' />

                        <div className='medical-history__row'>
                          <span className='medical-history__label'>진단명</span>
                          <span className='medical-history__value'>{data.data.diagnosisName}</span>
                        </div>

                        <div className='medical-history__divider ' />

                        <div className='medical-history__row'>
                          <span className='medical-history__label'>진단일</span>
                          <span className='medical-history__value'>
                            {formatDateToKoreanWithWeekday(data.data.diagnosisDate.replace(/-/g, ''))}
                          </span>
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 검사 내역 */}
          {activeTab === 'test' && <InspectDetail />}
        </div>
      </div>
    </div>
  );
};

// 검사 카테고리 탭
export const InspectDetail = () => {
  const navigate = useNavigate();
  const { hspId, pactId, patientNumber } = useGetJsonParams();

  const [activeTab, setActiveTab] = useState('ALL');

  const scrollAreaRef = useRef(null);
  useEffect(() => {
    if (scrollAreaRef.current) scrollAreaRef.current.scrollTo(0, 0);
  }, [activeTab]);
  const [tabs] = useState([
    {
      key: 'ALL',
      label: '전체',
    },
    {
      key: 'SPC',
      label: '검체',
    },
    {
      key: 'IMG',
      label: '영상',
    },
    {
      key: 'FUNC',
      label: '기능',
    },
  ]);

  const { data } = useGetPactTest({
    hspId,
    pactId,
    patientNumber,
  });
  // useEffect(() => {
  //   if (!data) return;
  //   const tabList = [];

  //   data.tests?.map((test) => {
  //     if (!tabList.includes(test.testType)) tabList.push(test.testType);
  //   });
  //   setTabs([
  //     {
  //       key: 'ALL',
  //       label: '전체',
  //     },
  //     ...tabList.map((item) => ({
  //       key: item,
  //       label: testType[item],
  //     })),
  //   ]);
  // }, [data]);

  const scrollRef = useRef(null);
  if (!data) return null;
  return (
    <div className='inspect-result'>
      {data?.tests.length ? (
        <div className='inspect-result-content'>
          {/*  카테고리 탭  */}
          <div
            className='inspect-result__tabs'
            onWheel={(e) => {
              e.currentTarget.scrollLeft += e.deltaY;
            }}
          >
            {(() => {
              return (
                <div className='tabs-wrap' ref={scrollRef}>
                  <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} variant='filter' />
                </div>
              );
            })()}
          </div>

          <div className='section-container' ref={scrollAreaRef}>
            {(() => {
              const TEST_LIST = activeTab === 'ALL' ? Object.keys(testType) : [activeTab];

              return TEST_LIST.map((testKey, idx) => {
                const items = data.tests.filter((test) => test.testType === testKey);
                return (
                  <Fragment key={testKey}>
                    <section className={`inspect-section ${!items.length ? 'no-data' : ''}`}>
                      <h2 className='inspect-section__title'>
                        {testType[testKey]}검사 <span>{items.length}</span>
                      </h2>

                      {items.length > 0 ? (
                        <>
                          {items.map((item) => (
                            <div
                              className='inspect-card'
                              key={`${item.testId}${item.testName}`}
                              onClick={() => {
                                if (item.testType === 'SPC')
                                  navigate(
                                    '/karenote/specimens' +
                                      window.location.search +
                                      `&testId=${item.testId}&testDate=${item.testDate}&resultDate=${item.resultDate}&testName=${item.testName}`,
                                  );
                              }}
                            >
                              <div className='inspect-card__header'>
                                <strong>{item.testName}</strong>
                                <div className='badge-wrap'>
                                  {item.abnormalFlag === 'Y' && (
                                    <span className='badge badge--alert'>
                                      <img src={cautionIcon} alt='' />
                                      확인 필요
                                    </span>
                                  )}
                                  {item.testType === 'SPC' && (
                                    <span className='badge-wrap--arrow'>
                                      <img src={arrow} alt='' />
                                    </span>
                                  )}
                                </div>
                              </div>
                              <span className='inspect-card__date'>
                                <span>
                                  <span>검사일</span>
                                  <span>{formatDateToKoreanWithWeekday(item.testDate.replace(/-/g, ''))}</span>
                                </span>
                              </span>
                            </div>
                          ))}
                        </>
                      ) : (
                        <p className='inspect-section__empty'>조회 가능한 검사가 없어요.</p>
                      )}
                    </section>
                    {idx !== TEST_LIST.length - 1 && <div className='section-diviver' />}
                  </Fragment>
                );
              });
            })()}
          </div>
        </div>
      ) : (
        <div className='inspect-empty-wrap'>
          <img src={inspectEmptyIcon} alt='조회 가능한 검사 없음' />
          <p>조회 가능한 검사가 없어요.</p>
        </div>
      )}
    </div>
  );
};

